import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/services/dialog-service.service';
import { UserService } from 'src/app/services/http/user/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  username!: string;

  constructor(
    private userService: UserService,
    private router: Router,
    private dialogService: DialogService
  ) {}

  /**
   * Method called whe the user clicks the 'Login' button
   * @param f the NgForm that the user filled
   */
  onSubmit(f: NgForm) {
    var formData: any = new FormData();
    formData.append('login', f.value.username);
    formData.append('password', f.value.password);

    this.userService.postLogin(formData).subscribe(
      (data: any) => {
        // console.log(data);
        this.onLoginSuccess(data);
        this.userService.changeUsername(f.value.username);
        this.userService.sharedUsername.subscribe(
          (username) => (this.username = username)
        );
      },
      (failure: any) => {
        this.onLoginFailure(failure);
      }
    );
  }
  /**
   * Callback when login fails
   * @param failure the error that occured while attempting to login
   */
  onLoginFailure(failure: any) {
    console.error('Login failed:', failure);

    const message =
      failure?.error?.message || failure?.message || JSON.stringify(failure);
    const status = failure?.status;

    if (status === 401 || message.includes('401')) {
      this.dialogService.openDialog(
        'Oups',
        'Login ou mot de passe incorrect',
        '300px'
      );
    } else {
      this.dialogService.openDialog(
        'Erreur',
        'Une erreur s’est produite lors de la connexion',
        '300px'
      );
    }
  }

  /**
   * Callback when user has succesfully logged-in
   * @param data token: tring, restricted: string[] || undefined
   * data.restricted is authorized menu navigation array ( ie: ['/installations-list', '/home', ...] )
   */
  onLoginSuccess(data: any) {
    /**
     * Call UserService onLogin method
     */
    this.userService.onLogin(data);

    /**
     * Navigate to /home page (default) or to first authorized menu item
     */
    if (data.restricted) {
      this.router.navigate([data.restricted[0]]);
    } else {
      this.router.navigate(['/home']);
    }
  }
}
